import { render, staticRenderFns } from "./PriceIQFrame.vue?vue&type=template&id=354a2764"
import script from "./PriceIQFrame.vue?vue&type=script&lang=js"
export * from "./PriceIQFrame.vue?vue&type=script&lang=js"
import style0 from "./PriceIQFrame.vue?vue&type=style&index=0&id=354a2764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports